module.exports = __webpack_public_path__ + "static/media/1.61ad1010.jpg";